import { COLORS } from '../../../config/designSystem/Colors';
import { ParagraphMRegular } from '../../../config/designSystem/typography';
import { SPACING } from '../../../config/designSystem/Spacing';
import { ActivityIndicator, StyleSheet, View } from 'react-native';

interface DashboardLoadingOverlayProps {
  message: string;
}

export const DashboardLoadingOverlay = ({ message }: DashboardLoadingOverlayProps) => {
  return (
    <View style={styles.overlay}>
      <ActivityIndicator size="large" color={COLORS.brand[500]} />
      <ParagraphMRegular color={COLORS.content.secondary} style={styles.text}>
        {message}
      </ParagraphMRegular>
    </View>
  );
};

const styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.surface.primary,
    zIndex: 500,
  },
  text: {
    marginTop: SPACING['sp-16'],
  },
});
